import { getTimeFromSeconds } from '@/helpers/math';
import ProgressBar from '@/components/app/ProgressBar';
import Text, { FONT_SIZE_040 } from '@/components/component-library/Text';
import useMusicPlayerSeekerBar from '@/hooks/audio/useMusicPlayerSeekerBar';
import useMusicPlayerState from '@/hooks/audio/useMusicPlayerState';

const DesktopSeekSection = () => {
  const { episode } = useMusicPlayerState();
  const {
    current,
    disableSeek,
    handleSeek,
    handleMoveSlider
  } = useMusicPlayerSeekerBar();
  const duration = episode?.duration || 0;

  return (
    <div className='desktop-progress-bar-wrapper'>
      <Text
        className='time'
        fixed
        size={ FONT_SIZE_040 }
      >
        { getTimeFromSeconds(current).timeString }
      </Text>
      <ProgressBar
        alwaysShowThumb
        className='desktop-progress-bar'
        disableInteraction={ disableSeek }
        max={ duration }
        onMoveSlider={ handleMoveSlider }
        onSeek={ handleSeek }
        seek={ current }
        sliderProgressClassName='desktop-slider-progress'
      />
      <Text
        className='time'
        fixed
        size={ FONT_SIZE_040 }
      >
        { /* Evaluate whether this should display remaining, as with mobile design */ }
        { getTimeFromSeconds(duration).timeString }
      </Text>
    </div>
  );
};

export default DesktopSeekSection;